import { Component, OnInit } from '@angular/core';
import { IEmployee } from 'ng2-org-chart/src/employee';
import { EventProjectService, CustomerService, CommonService } from 'src/app/shared';
import { environment } from '../../environments/environment';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as QRCode from 'qrcode';
import * as moment from 'moment';

@Component({
  selector: 'app-setting-system',
  templateUrl: './setting-system.component.html',
  styleUrls: ['./setting-system.component.css']
})
export class SettingSystemComponent implements OnInit { 

    submitted_edit = false;
    editForm: FormGroup;
    showBeamApiKey = false;
    showBeamWebhookSecret = false;
  
    constructor(private fb: FormBuilder,
      private eventProjectService: EventProjectService,
      private customerService: CustomerService,
      private spinner: NgxSpinnerService,
      private commonService: CommonService) { 
  
      this.editForm = fb.group({
        'screen_timeout': ['', Validators.required],
        'countdown_take_photo': ['', Validators.required],
        'screen_interval': ['', Validators.required],
        'usage_time_screen': ['', Validators.required],
        'retention_days': ['', Validators.required],
        'beam_merchant_id': [''],
        'beam_api_key': [''],
        'beam_webhook_secret': [''],
        'print_photos_per_payment': [''],
      });
    }
  
    ngOnInit() {
      this.getDetail();
    }
  
    getDetail(){
      this.spinner.show();
      this.customerService.getCustomerDetail().subscribe(data=>{
        console.log(data)
        this.editForm.patchValue({
          screen_timeout: data.screen_timeout,
          countdown_take_photo: data.countdown_take_photo,
          screen_interval: data.screen_interval,
          usage_time_screen: data.usage_time_screen,
          retention_days: data.retention_days,
          beam_merchant_id: data.beam_merchant_id,
          beam_api_key: data.beam_api_key,
          beam_webhook_secret: data.beam_webhook_secret,
          print_photos_per_payment: data.print_photos_per_payment,
        });
        this.spinner.hide();
      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
    }

    confirm(){
      console.log(this.editForm.value);
      this.submitted_edit = true;
      if(this.editForm.invalid){
        return;
      }
      console.log(this.editForm.value);

      this.spinner.show();
      this.customerService.updateCustomerDetail(this.editForm.value).subscribe(data => {
        this.submitted_edit = false;
        this.spinner.hide();
        this.successDialog();
      }, error => {
        console.error(error);
        this.spinner.hide();
        this.failDialog('');
      });
    }
  
    maskKey(value: string): string {
      if (!value || value.length <= 15) return value;
      return value.substring(0, 9) + '*'.repeat(value.length - 15) + value.substring(value.length - 6);
    }

    successDialog(){
      Swal.fire("ทำรายการสำเร็จ!", "", "success");
    }
  
    failDialog(msg){
      Swal.fire({
        type: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: msg
      })
    }
  
  }
